import React, { useCallback, useState } from 'react'
import { SubscribeCtaProps } from './types'
import { SubscribeModal } from 'ppp'
import { gaEvent } from 'shared'

export const SubscribeCta = ({ projectTitle, url }: SubscribeCtaProps): JSX.Element => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__top')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__top')
    setShow(false)
  }, [])

  return (
    <>
      <p>{i18n.t('projects.show.engagement.subscribe_introduction')}</p>
      <button onClick={handleClick} className="simulated-link">
        {i18n.t('misc.learn_more_about_newsletter')}
      </button>

      <SubscribeModal show={show} projectTitle={projectTitle} url={url} onHide={onHide} />
    </>
  )
}
